/**
 * This function mutates the widget object before it is submitted
 *
 * @name prepareWidgetForSubmit
 * @function
 * @param { Object } widget - (see widget/types for more details)
 * @returns the widget object with potential modifications
 */
export const prepareWidgetForSubmit = (widget) => {
    // For trending widgets, we dont want to pass any date filters, particularly the estimated_published_date permanentFilter
    if (widget.meta && widget.meta.widget_type === DjangIO.app.widgets.types.DashboardWidgetType.trending_widget.value) {
        widget.data_sources.map(dataSource => (
            dataSource.safed_search.filters.map(filterObj => {
                delete filterObj.estimated_published_date__gt
                return filterObj
            })
        ))
    }
    return widget
}
